import React from "react";
import Loader from 'react-loader-spinner'
import Modal from "../components/Modal";
import { translate } from "../utils/useful";


class RemoveModal extends React.Component {
  state = {
    isLoadingRemove: false,
    id: null,
    index: null
  }

  showModal = (id, index) => {
    this.setState({ id, index })
    this.removeModal.showModal()
  }

  // hideModal = () => {
  //   this.removeModal.hideModal()
  // }


  render() {
    return (
      <Modal cancelModal={this.props.cancelModal} ref={el => this.modal = el} maxWidth={320} className="flexcc text-center">
        <div className="w-100 h-100 p-4" style={{ backgroundColor: '#fff', borderRadius: 8 }}>
          <div className="flexcc flex-column">

            <img src={'/images/remove.png'} alt="" width="50px" />

            <p className="mt-3 text-small">{translate("Are you sure you want to delete?")}</p>
          </div>


          {!this.props.isLoading && (
            <div className=" mt-3 px-2">
              {/* <button onClick={() => this.actionClicked(prop, index)} className="w-100" style={{ backgroundColor: prop.bg ? prop.bg : '#F87C56', borderRadius: 50, padding: '8px 15px', }}>
                                                    <p className="text-bold text-uppercase text-normal" style={{ color: prop.color ? prop.color : '#fff', fontWeight: "400", fontSize: 14 }}>{onlyView ? translate('View') : checkTranslation(prop.label)}</p>
                                                </button> */}
              <button className="mb-2 white text-uppercase w-100" onClick={() => { this.props.removeFunction(this.state.id, this.state.index) }} style={{ backgroundColor: '#184d94', borderRadius: 50, padding: '8px 15px', }}>
                <p style={{ textAlign: 'center', fontWeight: "400", fontSize: 14, color: "#fff" }}>{translate('Delete')}</p>
              </button>
              <button className=" white text-uppercase w-100" onClick={() => this.modal.hideModal()} style={{ backgroundColor: '#efefef', borderRadius: 50, padding: '8px 15px', }}>
                <p style={{ textAlign: 'center', fontWeight: "400", fontSize: 14, color: "#222" }}>{(translate('Cancel'))}</p>
              </button>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {this.props.isLoading && (
              <Loader
                type="Puff"
                color="rgba(0,122,255,1)"
                height="40"
                width="40"
              />)}
          </div>
        </div>

      </Modal >
    );
  }
}



export default RemoveModal;
